var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-group" }, [
    _vm.collapsed
      ? _c("div", { staticClass: "nav-group__divider" })
      : _vm.title
      ? _c("div", { staticClass: "nav-group__label" }, [
          _vm._v(_vm._s(_vm.title))
        ])
      : _vm._e(),
    _c("div", { staticClass: "nav-group__items" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }